module.exports = __webpack_public_path__ + "img/stock.83773970.svg";